import React, { useEffect } from 'react';
import "./HouseKeepingDecision.css";
import Header from '../../../components/Header';
import useAuth from '../../../../customHooks/useAuth';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import Remarks from '../../../components/Remarks/Remarks';
import { baseUrl } from '../../../../common/baseUrl';
import axiosInstance from '../../../../axiosInstance/axiosInstance';
import { HOTEL_TIMEZONE } from "../../../../common/hotelTime";

export default function HouseKeepingDecision() {

    const location = useLocation();
    const navigate = useNavigate();
    
    // Refresh Handle
    useAuth();

    const bookingId = location.state?.bookingId || "";
    const bookedRoomId = location.state?.bookedRoomId || "";
    const userId = location.state?.userId || "";
    const requestId = location.state?.requestId || "";
    const hotelId= location.state?.hotelId || "";
    const status = location.state?.status || "";
    const houseKeepingData = location.state?.data || {};
    const staffStatus = location.state?.staffStatus || "";

    

    useEffect(()=>{

        const checkId = () =>{
            if(bookedRoomId==="" || hotelId==="" || bookingId===""){
                navigate("/bookings");
            }
        }
        checkId();
    },[hotelId,bookedRoomId,bookingId,navigate]);

    // Function to format the date (e.g., "07 Oct")
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate();
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
        const month = monthNames[date.getMonth()];
        return `${day} ${month}`;
    };

    // Function to format the time (e.g., "22:11")
    const formatTime = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleTimeString([], {
            timeZone: HOTEL_TIMEZONE, hour: '2-digit', minute: '2-digit' });
    };

    const closeRequest = async()=>{
        try{
            const response = await axiosInstance.put(`/api/v1/users/${userId}/guest-requests/${requestId}/close`);
            // console.log("Request Cancelled : ",response.data);
            toast.success("HouseKeeping Request Cancelled Successfully");
            navigate("/bookings",{state : {activeRequests : "requests"}});

        }catch(error){
            toast.error(error.response.data.message);
            console.log(error);
        }
    }

  return (
    <div className='houseKeepingDecison'>
        <Header title="Request for Housekeeping Service" para="Keeping your room clean and comfortable is our priority! You can easily request housekeeping services directly through our app" />

      
        <div className='housekeeping-data'>

            {/* Status */}
            {staffStatus && 
                <div className="housekeeping-status">
                    <h4>{staffStatus}</h4>
                </div>
            }
            
            {/* Room  */}
            <div className='housekeeping-dataService'>
                <h4>Service Room</h4>
                <div className='housekeeping-data-room'>
                    <h5>{houseKeepingData.service_room}</h5>
                </div>
            </div>

            {/* Select Housekeeping Service */}
            <div className='housekeeping-dataService'>
                <h4>Select Housekeeping Service</h4>
                <div className='housekeeping-data-serviceName'>
                    <h5>{houseKeepingData.housekeeping_service_name}</h5>
                </div>
            </div>

            {/* Comments */}
            {houseKeepingData.additional_comments && 
                <div className='housekeeping-dataService'>
                    <h4>Comments</h4>
                    <div className='housekeeping-data-comment'>
                        <h5>{houseKeepingData.additional_comments}</h5>
                    </div>
                </div>
            }

            {/* Date of the serivce */}
            <div className='housekeeping-dataService'>
                <h4>Date of the serivce</h4>
                <div className='housekeeping-data-serviceDateData'>
                    <h5>{formatDate(houseKeepingData.preferred_time)}</h5>
                </div>
            </div>

            {/* When do you want the service */}
            <div className='housekeeping-dataService'>
                <h4>When do you want the service</h4>
                <div className='housekeeping-data-serviceDateTime'>
                    <h5>{formatTime(houseKeepingData.preferred_time)}</h5>
                </div>
            </div>

            {/* Remarks */}
            {
                houseKeepingData.remarks && houseKeepingData.remarks!=="" &&   <Remarks
                    para={houseKeepingData.remarks}
                />
            }
          
            
            {
                !(status === "Completed_Hotel" || status === "Declined_Hotel" || status === "Declined_Guest" || status === "Closed_Hotel" || status === "Closed_Guest") && (
                    <div className='cancelButton-service'>
                        <button onClick={closeRequest}>Cancel Request</button>
                    </div>
                )
            }

        </div>
    </div>
  )
}
